import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "../table/table";
import { getAllSchemeFundPerformanceData, getSchemeFundPerformanceDataByFilter } from "../../utils/util";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { IndianRupee } from "lucide-react";


const Performance = ({selectedSchemeOptions=[],footer=true,setSchemeFundPerformanceDataForPDF=()=>{}}) => {

  const [schemeFundPerformanceData,setSchemeFundPerformanceData]=useState()
  const investorInfo=useSelector(state=>state.investorInfo)
  const userInfo=useSelector(state=>state.user)
  const dispatch=useDispatch()

  const total_investment = selectedSchemeOptions.length > 0 
  ? investorInfo && investorInfo?.schemes && investorInfo?.schemes
      .filter(scheme => {
        const [schemeName, schemeClass] = selectedSchemeOptions[0].split("-");
        return scheme.scheme_class === schemeClass && scheme.scheme_name === schemeName;
      })
      .map(scheme => scheme.contribution)
  : [];

  console.log("total_investment",total_investment);


  const total_investmentred = selectedSchemeOptions.length > 0 
  ? investorInfo && investorInfo?.schemes && investorInfo?.schemes
      .filter(scheme => {
        const [schemeName, schemeClass] = selectedSchemeOptions[0].split("-");
        return scheme.scheme_class === schemeClass && scheme.scheme_name === schemeName;
      })
      .reduce((sum, scheme) => sum + Number(scheme.contribution || 0), 0)
  : 0;

  console.log("total_investmentred",total_investmentred);
  
  // const handleGetAllSchemeFundPerformanceData=async()=>{
  //   try {
  //     const response=await getAllSchemeFundPerformanceData()
  //     console.log("Response for handleGetAllSchemeFundPerformanceData function",response)
  //   } catch (error) {
  //     console.log("Errorn in handleGetAllSchemeFundPerformanceData function",error)
  //   }
  // }

  // const handleGetSchemeFundPerformanceDataByFilter=async()=>{
  //   dispatch(loaderSet(true))
  //   const payload={
  //     scheme_name:"Vasuki India",
  //     scheme_class:"A"
  //   }
  //   try {
  //     const response=await getSchemeFundPerformanceDataByFilter(payload)
  //     console.log("Response for handleGetSchemeFundPerformanceDataByFilter ",response)
  //     if(response){
  //       setSchemeFundPerformanceData(response?.data[0])
  //     }
  //     dispatch(loaderSet(false))
  //   } catch (error) {
  //     console.log("Error in handleGetSchemeFundPerformanceDataByFilter function",error)
  //     dispatch(loaderSet(false))
  //   }

  // }

  // useEffect(()=>{
  //   handleGetSchemeFundPerformanceDataByFilter()
  //   handleGetAllSchemeFundPerformanceData()
  // },[])

  // const allSchemeDetails = useSelector(state => state.allSchemeDetails);
  const allSchemeDetails = useSelector(state => state.schemeInfoAgainstInvestor);
  useEffect(() => {
    if (selectedSchemeOptions && selectedSchemeOptions.length > 0 && allSchemeDetails && allSchemeDetails.length > 0) {
      const schemeName = selectedSchemeOptions[0]?.split("-")[0];
      const schemeClass = selectedSchemeOptions[0]?.split("-")[1];
  
      const innerBlockSchemePerformnceData = allSchemeDetails.filter((overviewData) => (
        overviewData.scheme_name === schemeName && overviewData.scheme_class === schemeClass
      ));
  
      setSchemeFundPerformanceData(innerBlockSchemePerformnceData[0])
      setSchemeFundPerformanceDataForPDF(innerBlockSchemePerformnceData[0])
      // You can now use innerBlockSchemeOverviewData for further actions
      console.log("setSchemeFundPerformanceData(innerBlockSchemeOverviewData)",innerBlockSchemePerformnceData);
    }
  }, [selectedSchemeOptions, allSchemeDetails]);
  




  // const invoices = [
  //   {
  //     returns: "Scheme Returns (%)",
  //     oneMonths:!schemeFundPerformanceData?.scheme_return?.one_month?"N/A": `${(schemeFundPerformanceData?.scheme_return?.one_month * 100).toFixed(2)}%`,
  //     threeMonths:!schemeFundPerformanceData?.scheme_return?.three_month?"N/A": `${(schemeFundPerformanceData?.scheme_return?.three_month * 100).toFixed(2)}%`,
  //     sixMonths:!schemeFundPerformanceData?.scheme_return?.six_months?"N/A": `${(schemeFundPerformanceData?.scheme_return?.six_months * 100).toFixed(2)}%`,
  //     oneYear:!schemeFundPerformanceData?.scheme_return?.one_year?"N/A" :`${(schemeFundPerformanceData?.scheme_return?.one_year * 100).toFixed(2)}%`,
  //     sinceInception: !schemeFundPerformanceData?.scheme_return?.since_inception?"N/A":`${(schemeFundPerformanceData?.scheme_return?.since_inception * 100).toFixed(2)}%`,
  //   },
  //   {
  //     returns: "Benchmark Returns (%)",
  //     oneMonths:!schemeFundPerformanceData?.benchmark_return?.one_month?"N/A": `${(schemeFundPerformanceData?.benchmark_return?.one_month * 100).toFixed(2)}%`,
  //     threeMonths:!schemeFundPerformanceData?.benchmark_return?.three_month?"N/A": `${(schemeFundPerformanceData?.benchmark_return?.three_month * 100).toFixed(2)}%`,
  //     sixMonths: !schemeFundPerformanceData?.benchmark_return?.six_months?"N/A":`${(schemeFundPerformanceData?.benchmark_return?.six_months * 100).toFixed(2)}%`,
  //     oneYear: !schemeFundPerformanceData?.benchmark_return?.one_year?"N/A":`${(schemeFundPerformanceData?.benchmark_return?.one_year * 100).toFixed(2)}%`,
  //     sinceInception: !schemeFundPerformanceData?.benchmark_return?.since_inception?"N/A":`${(schemeFundPerformanceData?.benchmark_return?.since_inception * 100).toFixed(2)}%`,
  //   },
  // ];
  

  const invoices = [
    {
      returns: "Scheme Returns (%)",
      oneMonths: !schemeFundPerformanceData?.scheme_return?.one_month
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.scheme_return?.one_month * 100)}%`,
      threeMonths: !schemeFundPerformanceData?.scheme_return?.three_month
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.scheme_return?.three_month * 100)}%`,
      sixMonths: !schemeFundPerformanceData?.scheme_return?.six_months
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.scheme_return?.six_months * 100)}%`,
      oneYear: !schemeFundPerformanceData?.scheme_return?.one_year
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.scheme_return?.one_year * 100)}%`,
      sinceInception: !schemeFundPerformanceData?.scheme_return?.since_inception
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.scheme_return?.since_inception * 100)}%`,
    },
    {
      returns: "Benchmark Returns (%)",
      oneMonths: !schemeFundPerformanceData?.benchmark_return?.one_month
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.benchmark_return?.one_month * 100)}%`,
      threeMonths: !schemeFundPerformanceData?.benchmark_return?.three_month
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.benchmark_return?.three_month * 100)}%`,
      sixMonths: !schemeFundPerformanceData?.benchmark_return?.six_months
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.benchmark_return?.six_months * 100)}%`,
      oneYear: !schemeFundPerformanceData?.benchmark_return?.one_year
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.benchmark_return?.one_year * 100)}%`,
      sinceInception: !schemeFundPerformanceData?.benchmark_return?.since_inception
        ? "N/A"
        : `${Math.round(schemeFundPerformanceData?.benchmark_return?.since_inception * 100)}%`,
    },
  ];
  
  

  // const invoiceTwo = [
  //   {
  //     returns: "Scheme (Rs.)",
  //     oneMonths: !schemeFundPerformanceData?.scheme_return?.one_month?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.one_month / 100)).toFixed(2)}`,
  //     threeMonths: !schemeFundPerformanceData?.scheme_return?.three_month?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.three_month / 100)).toFixed(2)}`,
   
  //     sixMonths: !schemeFundPerformanceData?.scheme_return?.six_months?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.six_months / 100)).toFixed(2)}`,
  //     // sixMonths: `${100000 + (100000 * 5 / 100)}%` // => 105000%



  //     oneYear:!schemeFundPerformanceData?.scheme_return?.one_year?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.one_year / 100)).toFixed(2)}`,
  //     sinceInception: !schemeFundPerformanceData?.scheme_return?.since_inception?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.since_inception / 100)).toFixed(2)}`,
  //   },
  //   {
  //     returns: "Benchmark (Rs.)#",
  //     oneMonths: !schemeFundPerformanceData?.benchmark_return?.one_month?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.one_month / 100)).toFixed(2)}`,
  //     threeMonths: !schemeFundPerformanceData?.benchmark_return?.three_month?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.three_month / 100)).toFixed(2)}`,
 
  //     sixMonths: !schemeFundPerformanceData?.benchmark_return?.six_months?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.six_months / 100)).toFixed(2)}`,
  //     oneYear: !schemeFundPerformanceData?.benchmark_return?.one_year?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.one_year / 100)).toFixed(2)}`,
  //     sinceInception: !schemeFundPerformanceData?.benchmark_return?.since_inception?"N/A":`${(investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.since_inception / 100)).toFixed(2)}`,
  //   },
  // ];


  // const invoiceTwo = [
  //   {
  //     returns: "Scheme (Rs.)",
  //     oneMonths: !schemeFundPerformanceData?.scheme_return?.one_month
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.one_month / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     threeMonths: !schemeFundPerformanceData?.scheme_return?.three_month
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.three_month / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     sixMonths: !schemeFundPerformanceData?.scheme_return?.six_months
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.six_months / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     oneYear: !schemeFundPerformanceData?.scheme_return?.one_year
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.one_year / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     sinceInception: !schemeFundPerformanceData?.scheme_return?.since_inception
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.scheme_return?.since_inception / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //   },
  //   {
  //     returns: "Benchmark (Rs.)#",
  //     oneMonths: !schemeFundPerformanceData?.benchmark_return?.one_month
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.one_month / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     threeMonths: !schemeFundPerformanceData?.benchmark_return?.three_month
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.three_month / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     sixMonths: !schemeFundPerformanceData?.benchmark_return?.six_months
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.six_months / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     oneYear: !schemeFundPerformanceData?.benchmark_return?.one_year
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.one_year / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //     sinceInception: !schemeFundPerformanceData?.benchmark_return?.since_inception
  //       ? "N/A"
  //       : `${(Number((investorInfo?.total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.since_inception / 100)).toFixed(2))).toLocaleString('en-IN')}`,
  //   },
  // ];
  

  // --------------------------------------------

//   const invoiceTwo = [
//     {
//       returns: (
//         <>
//           Scheme (
//           <span className="inline-block align-middle">
//             <IndianRupee size={15} />
//           </span>
//           )
//         </>

//       ),
//       oneMonths: !schemeFundPerformanceData?.scheme_return?.one_month
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.scheme_return?.one_month / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       threeMonths: !schemeFundPerformanceData?.scheme_return?.three_month
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.scheme_return?.three_month / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       sixMonths: !schemeFundPerformanceData?.scheme_return?.six_months
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.scheme_return?.six_months / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       oneYear: !schemeFundPerformanceData?.scheme_return?.one_year
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.scheme_return?.one_year / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       sinceInception: !schemeFundPerformanceData?.scheme_return?.since_inception
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.scheme_return?.since_inception / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//     {
//       returns: (
//         <>
//   Benchmark (
//   <span className="inline-block align-middle">
//     <IndianRupee size={15} />
//   </span>
//   )
// </>

//       ),
//       oneMonths: !schemeFundPerformanceData?.benchmark_return?.one_month
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.one_month / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       threeMonths: !schemeFundPerformanceData?.benchmark_return?.three_month
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.three_month / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       sixMonths: !schemeFundPerformanceData?.benchmark_return?.six_months
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.six_months / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       oneYear: !schemeFundPerformanceData?.benchmark_return?.one_year
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.one_year / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       sinceInception: !schemeFundPerformanceData?.benchmark_return?.since_inception
//         ? "N/A"
//         : `${(Number((total_investment * (1 + schemeFundPerformanceData?.benchmark_return?.since_inception / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//   ];


// ----------------------------------------------

  const invoiceTwo = [
  {
    returns: (
      <>
        Scheme (
        <span className="inline-block align-middle">
          <IndianRupee size={15} />
        </span>
        )
      </>
    ),
    oneMonths: !schemeFundPerformanceData?.scheme_return?.one_month
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.scheme_return.one_month))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    threeMonths: !schemeFundPerformanceData?.scheme_return?.three_month
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.scheme_return.three_month))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    sixMonths: !schemeFundPerformanceData?.scheme_return?.six_months
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.scheme_return.six_months))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    oneYear: !schemeFundPerformanceData?.scheme_return?.one_year
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.scheme_return.one_year))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    sinceInception: !schemeFundPerformanceData?.scheme_return?.since_inception
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.scheme_return.since_inception))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  },
  {
    returns: (
      <>
        Benchmark (
        <span className="inline-block align-middle">
          <IndianRupee size={15} />
        </span>
        )
      </>
    ),
    oneMonths: !schemeFundPerformanceData?.benchmark_return?.one_month
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.benchmark_return.one_month))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    threeMonths: !schemeFundPerformanceData?.benchmark_return?.three_month
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.benchmark_return.three_month))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    sixMonths: !schemeFundPerformanceData?.benchmark_return?.six_months
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.benchmark_return.six_months))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    oneYear: !schemeFundPerformanceData?.benchmark_return?.one_year
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.benchmark_return.one_year))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    sinceInception: !schemeFundPerformanceData?.benchmark_return?.since_inception
      ? "N/A"
      : `${(
          total_investmentred +
          (total_investmentred * parseFloat(schemeFundPerformanceData.benchmark_return.since_inception))
        ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    },
  ];
  
//   console.log("total_investmentred", total_investmentred);
//   console.log("schemeFundPerformanceData", schemeFundPerformanceData);
// console.log("scheme_return", schemeFundPerformanceData?.scheme_return);
// console.log("one_month return", schemeFundPerformanceData?.scheme_return?.one_month);




  return (
    <>
      <div className=" ">
        <div className="text-2xl mt-6 font-bold bg-[#0E2841] text-white py-3 pl-2 rounded-sm mb-4">
          Performance
        </div>
        <div className="border border-white  rounded-lg">
          <Table overflowHidden={true}>
            <TableHeader>
              <TableRow>
                <TableHead scope="col" className="bg-[#0D215C] rounded-tl-lg">Returns</TableHead>
                <TableHead scope="col" className="border text-white font-bold border-white bg-[#0D215C] text-center">
                  1 Month
                </TableHead>
                <TableHead scope="col" className="border border-white bg-[#0D215C] text-white font-bold text-center">
                  3 Months
                </TableHead>
                <TableHead scope="col" className="border text-white font-bold border-white bg-[#0D215C] text-center">
                  6 Months
                </TableHead>
                <TableHead scope="col" className="border border-white bg-[#0D215C] text-white font-bold text-center">
                  1 Year
                </TableHead>
                <TableHead scope="col" className="border border-white bg-[#0D215C] text-center text-white font-bold rounded-tr-lg">
                  Since Inception
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              { invoices.map((invoice) => (
                <TableRow key={invoice.returns}>
                  <TableHead scope="row" className="font-semibold border border-white text-[#0D215C] ">
                    {invoice.returns}
                  </TableHead>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.oneMonths}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.threeMonths}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.sixMonths}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.oneYear}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.sinceInception}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableHead
                  scope="row"
                  className="whitespace-nowrap text-center text-lg font-bold text-black"
                  colSpan={6}
                >
                  Value of Investment of Rs. {(Number(total_investment).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                </TableHead>
              </TableRow>
            </TableFooter>
            <TableBody>
              {invoiceTwo.map((invoice) => (
                <TableRow key={invoice.returns}>
                  <TableHead scope="row" className="font-semibold border border-white text-[#0D215C]">
                    {invoice.returns}
                  </TableHead>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.oneMonths}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.threeMonths}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.sixMonths}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.oneYear}
                  </TableCell>
                  <TableCell className="border font-semibold border-white text-[#0D215C] text-center">
                    {invoice.sinceInception}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div className="px-6 py-4 text-black text-base font-medium">
            *Past performance may or may not be sustained in future and is not a
            guarantee of any future returns.
          </div>
        </div>
        {/* Disclaimer */}
        { footer && <p className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2">Note: Please reach out to us at <a href="mailto:vasuki.compliance@vasukiindia.com" className="text-blue-700 underline font-normal" aria-label="Email Vasuki Compliance">vasuki.compliance@vasukiindia.com</a> for more details
          </p>}
      <p  className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2" ></p>
    
      </div>
    </>
  );
};

export default Performance;
